/* src/app/components/doc-viewer-new/doc-viewer-context-panel-template/doc-viewer-context-panel-list.component.scss */
/*# sourceMappingURL=doc-viewer-context-panel-list.component.css.map */
